import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useStyles } from './styles/SearchBar.styles';

interface SearchBarProps {
    onSearch: (searchText: string) => void;
    value?: string;
    width?: number;
}

export const SearchBar = ({ onSearch, value, width }: SearchBarProps) => {
    const styles = useStyles();

    return (
        <TextField
            variant={'outlined'}
            size={'small'}
            value={value}
            className={styles.searchbar}
            style={width ? { width } : {}}
            placeholder={'Search'}
            onChange={(e) => onSearch(e.target.value)}
            hiddenLabel
            InputProps={{
                startAdornment: (
                    <InputAdornment className={styles.adornment} position={'start'}>
                        <SearchIcon fontSize='small' />
                    </InputAdornment>
                ),
                classes: {
                    notchedOutline: styles.notchedOutline,
                },
            }}
            onDoubleClick={async () => {
                const text = await navigator.clipboard.readText();
                onSearch(text);
            }}
        />
    );
};
